var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-prompt" },
    [
      _c(
        "vue-dropzone",
        {
          ref: "dropzone",
          attrs: {
            id: "invoice-dropzone",
            options: _vm.dropzoneOptions,
            useCustomSlot: "",
          },
          on: {
            "vdropzone-sending": _vm.sendingEvent,
            "vdropzone-success": _vm.fileSuccess,
          },
        },
        [
          _c("div", { staticClass: "columns is-vcentered" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                { staticClass: "control has-icons-right" },
                [
                  _vm._t("default"),
                  _vm._v(" "),
                  _c("div", [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.promptText,
                          expression: "promptText",
                        },
                      ],
                      staticClass: "textarea has-fixed-size",
                      attrs: {
                        id: "invoiceDropZone",
                        disabled: _vm.promptIsDisabled,
                        placeholder: "Sende eine Nachricht an ChatGPT",
                      },
                      domProps: { value: _vm.promptText },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.sendPrompt.apply(null, arguments)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.promptText = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "send-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-single-toggle has-border",
                          class: { "is-loading button": _vm.isSending },
                          attrs: { disabled: _vm.promptIsDisabled },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.sendPrompt.apply(null, arguments)
                            },
                          },
                        },
                        [
                          !_vm.isSending
                            ? _c(
                                "i",
                                { staticClass: "material-icons is-pointer" },
                                [_vm._v("send")]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                ],
                2
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }